module.exports = __webpack_public_path__ + "static/img/banner-h.36e05dad.png";